<template>
  <!-- 安防视频-->
  <div class="security">
    <el-form class="bginput" label-width="7rem">

      <el-form-item label="分类设置" v-for="(item,index) in tableData" :key="index">
        <el-row :gutter="0" style="margin-bottom:15px;">
          <el-col :span="4">
            <el-input v-model="item.name" placeholder="请录入"></el-input>
          </el-col>
          <el-col :span="8">
            <el-button v-if="index!=0" @click="genreDel(item,i)" size="small" type="danger">移除分类</el-button>
            <el-button @click="addUrl(item)" size="small" type="success">添加视频</el-button>
            <el-button v-if="index==tableData.length-1" size="small" @click="addGenre" type="success">添加分类</el-button>
          </el-col>
        </el-row>

        <el-row :gutter="0" style="margin-bottom:15px;" v-for="(ite,i) in item.child" :key="i">

          <el-form-item label="名称/协议">
            <el-row :gutter="0">
              <el-col :span="6">
                <el-input v-model="ite.videoName" placeholder="请录入视频名称"></el-input>
              </el-col>

              <el-col :span="4">
                <el-select v-model="ite.transmode" placeholder="请选择协议">
                  <el-option label="UDP" value="0"></el-option>
                  <el-option label="TCP" value="1"></el-option>
                </el-select>
              </el-col>

            </el-row>
          </el-form-item>

          <el-form-item label="选择摄像头" style="margin-bottom:15px;">
            <el-row :gutter="0">
              <el-col :span="10">
                <el-select v-model="ite.videoUrl" placeholder="请选择">
                  <el-option v-for="(item,i) in cameraList" :key="i" :label="item.name" :value="item.indexCode"></el-option>
                </el-select>
              </el-col>
              <el-col :span="2">
                <i @click="del(ite,i,item.child)" class="el-icon-remove-outline" style="font-size: 1rem;line-height: 1.8rem;color: #f00;font-weight: 600;margin-left: 1rem;cursor: pointer;"></i>
              </el-col>
            </el-row>
          </el-form-item>

        </el-row>

      </el-form-item>

      <el-col :span="14">
        <div style="margin-top: 2rem;">
          <el-button @click="save" size="small" type="primary save">保存设置</el-button>
        </div>
      </el-col>
    </el-form>

  </div>

</template>

<script>
import api from '@/apis/safety/security'
import camera from '@/apis/safety/camera'
export default {
  data() {
    return {
      addUrlDialog: false,
      formData: {},
      tableData: [
        {
          name: '',
          child: [
            // {
            //   videoUrl: 'http://localhost:8080/#/system',
            // },
          ],
        },
      ],
      cameraList: [],
    }
  },
  mounted() {
    this.getlist()
    camera
      .cameraSearch({
        params: {
          pageNo: 1,
          pageSize: 1000,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          this.cameraList = res.data.data.list
        } else {
          this.$message.warning(res.message)
        }
      })


  },
  methods: {
    getlist() {
      api
        .list({
          params: {
            limit: 100,
            page: 1,
          },
        })
        .then((res) => {
          if (res.code === 10000) {
            if (res.data.length) {
              this.tableData = res.data
            }
          } else {
            this.$message.error(res.message)
          }
        })
    },
    addGenre() {
      //添加分类
      this.tableData.push({
        name: '',
        child: [],
      })
    },
    addUrl(item) {
      //添加分类
      if (item.child === null) {
        item.child = []
      }
      item.child.push({
        genreId: item.id,
        genreName: item.name,
        videoName: '',
        videoUrl: '',
        transmode: '1',
      })
    },
    save() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      //分类处理
      var genreData = []
      for (const iterator of this.tableData) {
        genreData.push({
          type: '1', //1安全 2 ai
          id: iterator.id,
          name: iterator.name,
        })
      }
      api.genreSave(genreData).then((res) => {
        if (res.code === 10000) {
          // this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      })
      //数据处理
      var listData = []
      for (const iterator of this.tableData) {
        if (iterator.child) {
          listData = listData.concat(iterator.child)
        }
      }
      api.save(listData).then((res) => {
        if (res.code === 10000) {
          this.getlist()
          loading.close()
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    del(item, i, obj) {
      this.$confirm(`确定删除此数据？`).then(() => {
        if (item.id) {
          for (const iterator of this.tableData) {
            if (iterator.id === undefined) {
              return this.$message.warning(
                '还有未保存的数据,请先保存后再删除！'
              )
            }
            if (iterator.child) {
              for (const item of iterator.child) {
                if (item.id === undefined) {
                  return this.$message.warning(
                    '还有未保存的数据,请先保存后再删除！'
                  )
                }
              }
            }
          }

          api.del([item.id]).then((res) => {
            if (res.code === 10000) {
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
            this.getlist()
          })
        } else {
          obj.splice(i, 1)
        }
      })
    },
    genreDel(item, i) {
      this.$confirm(`确定删除数据？`).then(() => {
        if (item.id) {
          for (const iterator of this.tableData) {
            if (iterator.id === undefined) {
              return this.$message.warning(
                '还有未保存的数据,请先保存后再删除！'
              )
            }
            if (iterator.child) {
              for (const item of iterator.child) {
                if (item.id === undefined) {
                  return this.$message.warning(
                    '还有未保存的数据,请先保存后再删除！'
                  )
                }
              }
            }
          }
          api.genreDel([item.id]).then((res) => {
            if (res.code === 10000) {
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
            this.getlist()
          })
        } else {
          this.tableData.splice(i, 1)
        }
      })
    },
  },
}
</script>

<style lang="less">
.security {
  padding-top: 10px;
}
</style>